import { render, staticRenderFns } from "./CardMini.vue?vue&type=template&id=1aabe0aa&"
import script from "./CardMini.vue?vue&type=script&lang=js&"
export * from "./CardMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports